(function (window, document, $) {

    $(document).ready(function () {

        // Load more buttons Infinity scroll ===========================================================================
        if ($('a[data-load-more-infinity-scroll]').length) {
            var window_height_percentage = ($(window).height() / 100) * 60;

            $(window).on('scroll', function (e) {

                $('a[data-load-more-infinity-scroll]').each(function (e) {

                    if( ($(window).scrollTop() + window_height_percentage) > $(this).offset().top 
                        && !$(this).hasClass('is-loading') 
                        && !$(this).hasClass('has-error')
                        && !$(this).hasClass('infinity-stop') ) {
                        $(this).before('<div class="infinity-scroll is-loading"></div>');
                        $(this).click();
                    }
                });
            });
        }

        // Load more buttons ===========================================================================================

        $('body').on('click', 'a[data-load-more]', function (e) {
            e.preventDefault();

            var $button = $(e.target),
                page = themevars.postID,
                post_type = $button.data('loadMoreType'),
                amount = $button.data('loadMoreAmount'),
                offset = $button.data('loadMoreOffset'),
                template = $button.data('loadMoreTemplate'),
                template_var = $button.data('loadMoreTemplateVar'),
                orderby = $button.data('loadMoreOrderby'),
                order = $button.data('loadMoreOrder'),
                search = ($button.data('loadMoreSearch')) ? $button.data('loadMoreSearch') : '',
                tag = ($button.data('loadMoreTag')) ? $button.data('loadMoreTag') : '',
                category = ($button.data('loadMoreCategory')) ? $button.data('loadMoreCategory') : '',
                query_key = ($button.data('loadMoreQueryKey')) ? $button.data('loadMoreQueryKey') : '',
                query_value = ($button.data('loadMoreQueryValue')) ? $button.data('loadMoreQueryValue') : '',
                query_compare = ($button.data('loadMoreQueryCompare')) ? $button.data('loadMoreQueryCompare') : '',
                restyling = ($button.data('loadMoreRestyling')) ? $button.data('loadMoreRestyling') : '',
                is_infinity_scroll = ($button.data('loadMoreInfinityScroll')) ? $button.data('loadMoreInfinityScroll') : '',
                $target = ($button.data('loadMoreTarget')) ? $($button.data('loadMoreTarget')) : $('[data-load-more-target="' + post_type + '"]');

            if (typeof themevars.ajaxurl !== 'undefined') {

                if (e.which) {
                    window.xhrPool.abortAll();
                }

                $button.removeClass('has-error');
                $button.addClass('is-loading');

                $.ajax({
                    type: 'POST',
                    url: themevars.ajaxurl,
                    data: {
                        action: 'get_posts',
                        page: page,
                        post_type: post_type,
                        template: template,
                        template_var: template_var,
                        amount: amount,
                        offset: offset,
                        orderby: orderby,
                        order: order,
                        s: search,
                        tag: tag,
                        category: category,
                        query_key: query_key,
                        query_value: query_value,
                        query_compare: query_compare,
                        restyling: restyling
                    },
                    dataType: 'json',

                    complete: function (e) {
                        $button.removeClass('is-loading');
                    },

                    success: function (response) {
                        if (response.hasOwnProperty('posts')) {

                            var newOffset = parseInt($button.data('loadMoreOffset'), 10) + response.posts.length;

                            $button.removeClass(['is-loading', 'has-error']);
                            $button.data('loadMoreOffset', newOffset);
                            $('[data-filter-count]').html( newOffset );
                            $('[data-filter-total]').html( response.count_total );

                            if ($button.prev().hasClass('infinity-scroll')) {
                                $button.prev().remove();
                            }

                            if (typeof $button.data('loadMoreCounter') !== 'undefined') {
                                $($button.data('loadMoreCounter')).text(newOffset);
                            }

                            for (var i in response.posts) {
                                if (response.posts.hasOwnProperty(i)) {
                                    var $wrapper = $target.children().first().clone();

                                    $wrapper
                                        .css('opacity', 0)
                                        .empty()
                                        .html($(response.posts[i].html))
                                        .appendTo($target)
                                        .delay(i * 100)
                                        .animate({ opacity: 1 });
                                }
                            }

                            if (response.datalayer_html) {
                                $target.append(response.datalayer_html);
                            }

                            if (newOffset < amount + offset || newOffset === response.count_total) {
                                if( is_infinity_scroll ) {
                                    $button.addClass( 'infinity-stop' );
                                } else {
                                    $button.remove();
                                }
                            }

                            /*if (post_type && post_type == "video") {
                                setHeartsFilled();
                            }*/

                            
                        } else {
                            return false;
                        }


                    },

                    error: function (e) {
                        $button.addClass('has-error');
                    }
                });

            } else {
                console.warn('AJAX URL is not defined...');
            }

        });
    });

}(window, document, jQuery));
